/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import Typography from "@mui/material/Typography";

import DOMPurify from "dompurify";
import { v7 as uuidv7 } from "uuid";

import openBetaImage from "../../../../../assets/images/OpenBeta_image_compressed.jpg";
import { useMediaQueries } from "../../../../../shared";
import Checkbox from "../../../../CheckBox/Checkbox";
import Separator from "../../../../Separator/Separator";
import { betaVersionCheckboxLabel, betaVersionParagraphs } from "../config";
import { useStyles } from "../styles";

import DialogParagraph from "./DialogParagraph";
import ListParagraph from "./ListParagraph";

interface BetaVersionContentProps {
  onCheckboxChange: () => void;
}

const BetaVersionContent = ({ onCheckboxChange }: BetaVersionContentProps) => {
  const { toMd } = useMediaQueries();

  const { textContainer } = useStyles();

  const imageWidthFromMd = "636px";
  const imageHeightFromMd = "318px";

  const formattedText = betaVersionParagraphs.map((paragraph) => (
    <div key={`${uuidv7()}`} css={css(textContainer)}>
      <Typography variant="body2SemiBold">
        {DOMPurify.sanitize(paragraph.title as any)}
      </Typography>

      {paragraph.description && (
        <DialogParagraph
          text={DOMPurify.sanitize(paragraph.description as any)}
        />
      )}
      {paragraph.beforeList && (
        <Typography variant="body2Medium">
          {DOMPurify.sanitize(paragraph.beforeList as any)}
        </Typography>
      )}
      {paragraph.list && <ListParagraph listItems={paragraph.list as any} />}
      {paragraph.afterParagraph && (
        <DialogParagraph
          text={DOMPurify.sanitize(paragraph.afterParagraph as any)}
        />
      )}
    </div>
  ));

  return (
    <>
      <img
        src={openBetaImage}
        alt="Closed Beta"
        width={toMd ? "100%" : imageWidthFromMd}
        height={toMd ? "auto" : imageHeightFromMd}
      />
      <div>{formattedText}</div>
      <Separator css={css({ marginBottom: "16px" })} />
      <Checkbox
        label={
          <span
            css={css({ span: { fontWeight: 600 } })}
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(betaVersionCheckboxLabel) // this type of code allows us to escape HTML tags.
            }}
          />
        }
        onChange={onCheckboxChange}
      />
    </>
  );
};

export default BetaVersionContent;
